<template>
  <div class="common-box CustomerManagement">
    <div>
      <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
        label-width="70px">
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="模板名称：">
              <el-input size="mini" v-model.trim="form.templateName" placeholder="请输入模板名称" clearable
                @change="handleSearchListData"></el-input>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" v-if="hasRole['GZMBTJ']" class="plr28" @click="jumpAdd">添加</el-button>
        <el-button size="mini" type="primary" v-if="hasRole['GZMBSC']" @click="deleteRowMore" class="plr28"
          plain>删除</el-button>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="templateName" label="模板名称" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注信息" width="150"></el-table-column>

          <el-table-column show-overflow-tooltip prop="updateUser" label="添加人员" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="updateTime" label="添加时间" width="150"></el-table-column>


          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="202px" fixed="right">
            <template slot-scope="scope">

              <el-button size="mini" type="text" v-if="hasRole['GZMBBJ']" @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide" v-if="hasRole['GZMBFZ']"></div>
              <el-button size="mini" type="text" v-if="hasRole['GZMBFZ']" @click="handleCopy(scope.row)">
                复制
              </el-button>

              <div class="btn-divide" v-if="hasRole['GZMBGZ']"></div>
              <el-button size="mini" type="text" v-if="hasRole['GZMBGZ']" @click="handleFlow(scope.row)">跟踪</el-button>
              <div class="btn-divide" v-if="hasRole['GZMBSC']"></div>
              <el-button size="mini" v-if="hasRole['GZMBSC']" type="text"
                @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>

    <AddUser v-if="showAddUser" :clientForm="rowDetail" @cancel="showAddUser = false" @confirm="finishAddUserConfirm" />
    <AddAssigne v-if="showBindLift" :clientForm="rowDetail" @cancel="showBindLift = false"
      @confirm="finishBindLiftConfirm" />
    <CheckUser v-if="showCode" :url="url" @cancel="showCode = false" />
  </div>
</template>

<script>
import {
  getPageList,
  deleteRow,
  copyData,
} from "@/api/salesManagement/gzmb.js";
import QRCode from 'qrcode'
import AddUser from "./components/AddUser.vue";
import CheckUser from "./components/CheckUser.vue";
import AddAssigne from "./components/AddAssigne.vue";

export default {
  name: "SalesManagementGZMB",
  components: {
    AddUser,
    CheckUser,
    AddAssigne
  },
  data() {
    return {
      form: {
        templateName: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      showAddUser: false,
      showBindLift: false,
      rowDetail: null,
      showCode: false,
      url: "",
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      const params = await this.getParams();
      const res = await getPageList(params);
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.rowDetail = row;
      this.showAddUser = true;
    },
    handleFlow(row) {
      this.rowDetail = row;
      this.showBindLift = true;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    deleteRowMore(row) {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteRow({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteRow(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteRow({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    jumpAdd() {
      this.rowDetail = null;
      this.showAddUser = true;
    },
    finishAddUserConfirm(v) {
      this.rowDetail = null;
      this.showAddUser = false;
      this.handleSearch();
    },
    finishBindLiftConfirm(v) {
      this.rowDetail = null;
      this.showBindLift = false;
      this.handleSearch();
    },
    // 列表排序
    handleSortChange({ column, prop, order }) {
      if (order === "ascending") {
        this.form.sortOrder = "asc";
        this.form.sortField = prop;
      } else if (order === "descending") {
        this.form.sortOrder = "desc";
        this.form.sortField = prop;
      } else {
        this.form.sortField = "";
        this.form.sortOrder = "";
      }
      this.getListData();
    },
    async getQRCodeFun(url) {
      const _myQRCode = await QRCode.toDataURL(url)
      return _myQRCode
    },
    async handleCopy(row) {
      this.$confirm("确定复制?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await copyData(row.id);
          if (res.code === 200) {
            this.$message.success("复制成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.CustomerManagement {
  .el-radio-group {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/gzmb/SalesManagementGZMB.vue